module.exports = __webpack_public_path__ + "img/alert-circle.b7094a6a.svg";